import { CustomSelectFieldProps, SelectField } from 'components/form'
import { IdentidadeGeneroEnum } from 'graphql/types.generated'

type IdentidadeGeneroValidaEnum = Exclude<IdentidadeGeneroEnum, IdentidadeGeneroEnum.TRANSGENERO>

type IdentidadeGeneroSelectFieldProps = CustomSelectFieldProps<IdentidadeGeneroEnum>

export function IdentidadeGeneroSelectField(props: IdentidadeGeneroSelectFieldProps) {
  return <SelectField<IdentidadeGeneroEnum> items={items} itemToString={renderItem} {...props} />
}

const renderItem = (item: IdentidadeGeneroEnum) => itemToString[item]

const itemToString: Record<IdentidadeGeneroValidaEnum, string> = {
  HOMEM_TRANS: 'Homem transgênero',
  MULHER_TRANS: 'Mulher transgênero',
  TRAVESTI: 'Travesti',
  HOMEM_CIS: 'Homem cisgênero',
  MULHER_CIS: 'Mulher cisgênero',
  NAO_BINARIO: 'Não-Binário',
  OUTRO_IDENTIDADE_GENERO: 'Outro',
}

export const items = Object.keys(itemToString) as IdentidadeGeneroEnum[]
